import type { HTMLAttributes, ReactNode } from 'react'

interface CrossCardProps extends HTMLAttributes<HTMLDivElement> {
  /** Small mono label in the top-left, e.g. "01". */
  index?: string
  /** Hover affordance for clickable cards. */
  interactive?: boolean
  children: ReactNode
}

/** Hairline frame with "+" registration marks at the corners. */
export function CrossCard({ index, interactive, className = '', children, ...rest }: CrossCardProps) {
  return (
    <div className={`cross-card ${className}`} data-interactive={interactive || undefined} {...rest}>
      <span className="cross-mark" data-pos="tl" aria-hidden />
      <span className="cross-mark" data-pos="tr" aria-hidden />
      <span className="cross-mark" data-pos="bl" aria-hidden />
      <span className="cross-mark" data-pos="br" aria-hidden />
      {index && <p className="label-mono mb-4">{index}</p>}
      {children}
    </div>
  )
}
